import React, { useContext } from 'react';
import styles from './SelectedAddressesForm.module.scss';
import HouseRegisterCheck from '../HouseRegisterCheck/HouseRegisterCheck';
import { SelectedItemsContext } from '../../../pages/ChangingAllPage/Provider';

const SelectedAddressesList = () => {
  const selectedItems = useContext(SelectedItemsContext);

  return (
    <div className={styles.lists}>
      {selectedItems?.map((select) => (
        <HouseRegisterCheck
          key={select.houseId}
          house={select}
        />
      ))}
    </div>
  );
};

const SelectedAddressesForm = () => {
  return (
    <div className={styles.conteiner}>
      <div className={styles.header}>
        <h3 className={styles.title}>Список выбранных адресов</h3>
      </div>
      <SelectedAddressesList />
    </div>
  );
};

export default SelectedAddressesForm;
